import { createContext, useContext, useState, ReactNode } from 'react';
import { BookingCreateDTO } from '../types/ZaprosDTO';

// Тип для контекста бронирования
type BookingContextType = {
  bookingData: BookingCreateDTO;
  setBookingData: (data: BookingCreateDTO) => void;
};

// Создание контекста с начальными значениями
const BookingContext = createContext<BookingContextType>({
  bookingData: {
    service_id: 0,
    object_id: 0,
    booking_date: '',
    start_time: '',
    end_time: '',
    quantity: 0,
    total_price: 0,
    added_to_cart_time: new Date().toISOString()
  },
  setBookingData: () => {}
});

// Провайдер контекста
export const BookingProvider = ({ children }: { children: ReactNode }) => {
  const [bookingData, setBookingData] = useState<BookingCreateDTO>({
    service_id: 0,
    object_id: 0,
    booking_date: '',
    start_time: '',
    end_time: '',
    quantity: 0,
    total_price: 0,
    added_to_cart_time: new Date().toISOString()
  });

  return (
    <BookingContext.Provider value={{ bookingData, setBookingData }}>
      {children}
    </BookingContext.Provider>
  );
};

// Хук для использования контекста
export const useBookingContext = () => useContext(BookingContext);